import React from 'react';

const TILES = [
  {
    icon: '🧠',
    title: 'Zu viele Gedanken',
    text: 'Ideen, Aufgaben und Notizen werden automatisch strukturiert – aus dem Chaos entsteht ein klarer Aktionsplan.',
  },
  {
    icon: '📝',
    title: 'Zu viele Meetings',
    text: 'Aus Transkripten entstehen automatisch Protokolle, Aufgaben und Follow-ups – in Sekunden statt Stunden.',
  },
  {
    icon: '⚖️',
    title: 'Zu viele Entscheidungen',
    text: 'KI hilft bei Risikoanalyse, Optionsvergleich und Priorisierung – damit du fundiert und schnell entscheidest.',
  },
  {
    icon: '⚡',
    title: 'Zu wenig Zeit',
    text: 'Wiederkehrende Aufgaben werden automatisiert und beschleunigt – damit du dich auf das Wesentliche konzentrierst.',
  },
  {
    icon: '📤',
    title: 'Verantwortlichkeiten verlieren sich nicht mehr',
    text: 'Delegierte Aufgaben, Wiedervorlagen und Verantwortlichkeiten bleiben transparent nachvollziehbar. TechSoul erinnert Führungskräfte automatisch an offene Themen und Kontrolltermine.',
  },
];

function WhyTechSoul() {
  return (
    <section className="why-techsoul reveal" id="ueber">
      <div className="section-header">
        <h2>Warum TechSoul?</h2>
        <p>Echte Führungsprobleme. Praktische Lösungen.</p>
      </div>
      <div className="why-grid why-grid--5">
        {TILES.map(({ icon, title, text }) => (
          <div key={title} className="why-tile">
            <div className="why-tile__icon">{icon}</div>
            <h3>{title}</h3>
            <p>{text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default WhyTechSoul;
